<form [formGroup]="vrijstellingenFg">
    <snelstart-ui-text-form-control class="custom-input-250 custom-readonly"
                                    formControlName="basisVrijstellingVanToepassing"
                                    id="basisVrijstellingVanToepassing"
                                    label="Basisvrijstelling van toepassing"
    >
    </snelstart-ui-text-form-control>
</form>


<div *ngIf="this.sbAangifte.begiftigde?.indicatieEerdereSchenking">
    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-number-form-control (change)="saveForm()"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-250"
                                          formControlName="alGebruikteBasisvrijstelling"
                                          id="alGebruikteBasisvrijstelling"
                                          label="Al gebruikte basisvrijstelling"
                                          prefix="€ -"
        >
        </snelstart-ui-number-form-control>
    </form>
</div>

<div *ngIf="isKindEnJongerDan40Result">

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="eenmaligVerhoogdeVrijstelling"
                                          id="eenmaligVerhoogdeVrijstelling"
                                          label="Eenmalige verhoogde vrijstelling kinderen"
        >
        </snelstart-ui-select-form-control>
    </form>

    <div *ngIf="this.vrijstellingenFg.get('eenmaligVerhoogdeVrijstelling')?.getRawValue() && this.sbAangifte.begiftigde?.indicatieEerdereSchenking">

        <form [formGroup]="vrijstellingenFg">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-250"
                                              formControlName="alGebruikteEenmaligeVerhoogdeVrijstelling"
                                              id="alGebruikteEenmaligeVerhoogdeVrijstelling"
                                              label="Al gebruikte eenmalig vrijstelling"
                                              prefix="€ -"
            >
            </snelstart-ui-number-form-control>
        </form>

    </div>

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="verhoogdeVrijstellingStudie"
                                          id="verhoogdeVrijstellingStudie"
                                          label="Verhoogde vrijstelling studie kinderen"
        >
        </snelstart-ui-select-form-control>
    </form>

    <div *ngIf="this.vrijstellingenFg.get('verhoogdeVrijstellingStudie')?.getRawValue()">


        <form [formGroup]="vrijstellingenFg">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-250"
                                              formControlName="bedragAlBetaaldDureStudie"
                                              id="bedragAlBetaaldDureStudie"
                                              label="Bedrag schenking al benut voor studie"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </form>


        <form [formGroup]="vrijstellingenFg">
            <snelstart-ui-number-form-control (change)="saveForm()"
                                              [showAllDecimals]="false"
                                              align="right"
                                              class="custom-input-250"
                                              formControlName="bedragNogTeBestedenDureStudie"
                                              id="bedragNogTeBestedenDureStudie"
                                              label="Bedrag schenking nog benutten voor studie"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </form>

        <div *ngIf="studieBedragTeLaag" style="width: 75%">
            <snelstart-ui-alert type="warning">
                Het totaalbedrag voor de dure studie moet minimaal € 20.000 zijn. Zie Toelichting.
            </snelstart-ui-alert>
        </div>
    </div>

</div>

<div *ngIf="this.dataService.hasKwijtschelding.getValue()">
    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="vrijstellingSchuldenaar"
                                          id="vrijstellingSchuldenaar"
                                          label="Vrijstelling kwijtschelding van oninbare vordering"
        >
        </snelstart-ui-select-form-control>
    </form>
</div>

<div class="row">

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="vrijstellingNatuurlijkeVerbintenis"
                                          id="vrijstellingNatuurlijkeVerbintenis"
                                          label="Vrijst. voldoen natuurlijke verbintenis"
        >
        </snelstart-ui-select-form-control>
    </form>
</div>

<div *ngIf="this.schenkingFg.get('relatieBegiftigdeMetSchenker')?.getRawValue() === SchenkingRelatieBegiftigdeMetSchenker.OVERIG">
    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="vrijstellingAnbiOfSbbi"
                                          id="vrijstellingAnbiOfSbbi"
                                          label="Vrijstelling voor ANBI's of SBBI's"
        >
        </snelstart-ui-select-form-control>
    </form>
</div>


<form [formGroup]="vrijstellingenFg">
    <snelstart-ui-select-form-control (change)="saveForm()"
                                      [options]="optionsJaNee"
                                      class="custom-input-250"
                                      formControlName="vrijstellingSchenkingBelastInIB"
                                      id="vrijstellingSchenkingBelastInIB"
                                      label="Vrijstelling samenloop ink.belasting"
    >
    </snelstart-ui-select-form-control>
</form>


<div *ngIf="this.schenkingFg.get('relatieBegiftigdeMetSchenker')?.getRawValue() === SchenkingRelatieBegiftigdeMetSchenker.OVERIG">

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-select-form-control (change)="saveForm()"
                                          [options]="optionsJaNee"
                                          class="custom-input-250"
                                          formControlName="vrijstellingSchenkingAanNabestaandeWerknemer"
                                          id="vrijstellingSchenkingAanNabestaandeWerknemer"
                                          label="Vrijstelling nabestaanden van werknemer"
        >
        </snelstart-ui-select-form-control>
    </form>
</div>

<div *ngIf="this.dataService.hasOnderneming.getValue()">

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-text-form-control class="custom-input-250 custom-readonly"
                                        formControlName="vrijstellingBedrijfsvermogenVanToepassing"
                                        id="vrijstellingBedrijfsvermogenVanToepassing"
                                        label="Vrijstelling i.v.m. bedrijfsopvolging"
        >
        </snelstart-ui-text-form-control>
    </form>

    <form [formGroup]="vrijstellingenFg">
        <snelstart-ui-number-form-control [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-250 custom-readonly"
                                          formControlName="vrijstellingBedrijfsvermogen"
                                          id="vrijstellingBedrijfsvermogen"
                                          label="Vrijstelling bedrijfsvermogen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
    </form>

</div>

<div class="pt-3">
    <div class="row">
        <div class="col col-1 bold">
            Bedrag van de vrijstellingen
        </div>
        <div class="col-2 bold">

        </div>
        <div class="col-2 bold">

        </div>
    </div>

    <div class="pt-3">
        <div class="row">
            <div class="col col-1">
                <p>Basisvrijstelling</p>
            </div>
            <div class="col-2"></div>
            <div *ngIf="!this.verhoogdeVrijstellingToegepast" class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150 custom-readonly"
                                                      formControlName="totaleBasisVrijstellingen"
                                                      id="totaleBasisVrijstellingen"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div *ngIf="this.verhoogdeVrijstellingToegepast" class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="nvt"
                                                      id="nvt"
                                                      placeholder="n.v.t."
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.sbAangifte.begiftigde?.indicatieEerdereSchenking">
        <div class="row">
            <div class="col col-1">
                <p>Al gebruikte basisvrijstelling</p>
            </div>
            <div class="col-2"></div>
            <div class="col-3">
                <form [formGroup]="vrijstellingenFg">
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150 custom-readonly"
                                                      formControlName="alGebruikteBasisvrijstelling"
                                                      id="alGebruikteBasisvrijstellingT"
                                                      prefix="€ -"
                    >
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.verhoogdeVrijstellingToegepast &&
                   (this.sbBerekening && this.sbBerekening.totaleVerhoogdeVrijstellingen &&
                        this.sbBerekening.totaleVerhoogdeVrijstellingen > 0)">
        <div class="row">
            <div class="col col-1">
                <p>Verhoogde vrijstelling(en)</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150 custom-readonly"
                            formControlName="totaleVerhoogdeVrijstellingen"
                            prefix="€">
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div *ngIf="this.overigeVrijstellingToegepast &&
                        (this.sbBerekening && this.sbBerekening.totalOverigeVrijstellingen &&
                        this.sbBerekening.totalOverigeVrijstellingen > 0)">
        <div class="row">
            <div class="col col-1">
                <p>Totaal overige vrijstellingen</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150 custom-readonly"
                            formControlName="totalOverigeVrijstellingen"
                            prefix="€">
                    </snelstart-ui-number-form-control>
                </form>
            </div>
        </div>
    </div>
    <div class="row col-auto">
        <div class="col col-1">
            <p>Totale vrijstellingen</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
            <form [formGroup]="sbBerekeningFg">
                <snelstart-ui-number-form-control
                        [showAllDecimals]="false"
                        align="right"
                        class="custom-input-150 custom-readonly"
                        formControlName="totaleVrijstellingen"
                        prefix="€">
                </snelstart-ui-number-form-control>
            </form>
        </div>
        <div class="col-4"></div>
    </div>
    <div *ngIf="this.sbBerekeningFg.get('eerderGebruikteVrijstellingen')?.getRawValue() !== null">
        <div class="row">
            <div class="col col-1">
                <p>Eerder gebruikte vrijstellingen</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150 custom-readonly"
                            formControlName="eerderGebruikteVrijstellingen"
                            prefix="€">
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Benutte vrijstellingen</p>
            </div>
            <div class="col-2">
            </div>
            <div class="col-3">
                <form [formGroup]="sbBerekeningFg">
                    <snelstart-ui-number-form-control
                            [showAllDecimals]="false"
                            align="right"
                            class="custom-input-150 custom-readonly"
                            formControlName="benutteVrijstellingen"
                            prefix="€">
                    </snelstart-ui-number-form-control>
                </form>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</div>
